import React from 'react';
import divider from '../../assets/divider-img.png';
import image from '../../assets/cust-report.png';

const CustomisedReport = () => {
  return (
    <div className="backtest-component">
      <div className="container">
        <div className="backtest-main-wrapper">
          <div className="backtest-heading-description align-c-768">
            <h2>Report Generation</h2>
            <div className="divider">
              <img src={divider} alt="divider" />
            </div>
            <p>
              Our system generates detailed reports that provide insights into
              the performance of your custom strategies. These reports aid in
              continuous strategy improvement and informed decision-making.
            </p>
          </div>
          <div className="backtest-content">
            <img src={image} alt="backtest-performance" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomisedReport;
